<img height="75" src="https://www.flacriminallawyer.com/wp-content/uploads/2015/12/Fort-Lauderdale-Criminal-Attorney-Jonathan-Friedman-Logo.jpg" />
<br /><br />


<div *ngIf="loading">Loading...</div>
<div *ngIf="loadError" class="alert alert-danger">{{ loadError }}</div>

<div *ngIf="caseResponse" class="case-details">
	<h4>Case Details</h4>
	<div class="name-value-table">
		<div class="name-value-row header-row">
			<div class="name-cell">Replacement</div>
			<div class="value-cell">Value (click to edit)</div>
			<div class="delete-cell"></div>
		</div>
		<div *ngFor="let field of formFields" 
		     class="name-value-row"
		     [class.editing]="isEditing(field.key)"
		     [class.editing-name]="isEditingName(field.key)"
		     [class.invalid-name]="field.isCustom && !isValidFieldName(getFieldLabel(field.key))">
			<div class="name-cell" 
			     [class.editable]="field.isCustom"
			     (click)="field.isCustom ? startEditName(field.key) : null">
				<span *ngIf="!isEditingName(field.key)" class="name-text">
					{{ getFieldLabel(field.key) || '(click to set name)' }}
				</span>
				<input *ngIf="isEditingName(field.key)" 
				       type="text" 
				       class="name-input"
				       [value]="getFieldLabel(field.key)"
				       (blur)="stopEditName()"
				       (keydown.enter)="stopEditName()"
				       (input)="updateFieldName(field.key, $any($event.target).value)"
				       placeholder="%FIELD_NAME%"
				       #nameInput />
				<div *ngIf="field.isCustom && getFieldNameValidationError(field.key)" class="validation-error">
					{{ getFieldNameValidationError(field.key) }}
				</div>
			</div>
			<div class="value-cell" (click)="startEdit(field.key)">
				<span *ngIf="!isEditing(field.key)" class="value-text">
					{{ getFieldValue(field.key) || '(empty)' }}
				</span>
				<input *ngIf="isEditing(field.key)" 
				       type="text" 
				       class="value-input"
				       [value]="getFieldValue(field.key)"
				       (blur)="stopEdit()"
				       (keydown.enter)="stopEdit()"
				       (input)="updateFieldValue(field.key, $any($event.target).value)"
				       #valueInput />
			</div>
			<div class="delete-cell" *ngIf="field.isCustom">
				<button class="delete-btn" (click)="deleteCustomField(field.key)" title="Delete row">
					<span class="delete-icon">✕</span>
				</button>
			</div>
		</div>
	</div>
	<a href="javascript:void(0)" class="add-field-link" (click)="addCustomField()">
		+ Add Additional Replacement Field
	</a>
</div>

<div class="google-docs-section" style="margin-top: 30px;">
	<h4>Available Google Docs Templates</h4>
	<div *ngIf="loadingDocs">Loading documents...</div>
	<div *ngIf="docsError" class="alert alert-danger">{{ docsError }}</div>
	<div *ngIf="!loadingDocs && googleDocs.length > 0">
		<select class="form-control" style="max-width: 500px;" [(ngModel)]="selectedTemplateId">
			<option value="">-- Select a template --</option>
			<option *ngFor="let doc of googleDocs" [value]="doc.id">{{ doc.name }}</option>
		</select>
		<button class="btn btn-primary" style="margin-top: 15px;" 
		        [disabled]="!selectedTemplateId || generatingDoc || hasValidationErrors()" 
		        (click)="generateDocument()">
			{{ generatingDoc ? 'Generating...' : 'Generate Document' }}
		</button>
		<div *ngIf="generateError" class="alert alert-danger" style="margin-top: 15px;">{{ generateError }}</div>
		<div *ngIf="generatedDocUrl" class="alert alert-success" style="margin-top: 15px;">
			Document generated successfully! 
			<a [href]="generatedDocUrl" target="_blank">Open Document</a>
		</div>
	</div>
	<div *ngIf="!loadingDocs && googleDocs.length === 0 && !docsError" class="alert alert-info">
		No Google Docs templates found.
	</div>
</div>


